export default {
  icon: {
    fill: 'currentColor',
  },
};
